import React from 'react'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { Container } from '@material-ui/core'
import imagePageInConstructionImage from '../../../assets/logos/construccion.jpg'
import './page-in-construction.css'

const PageInConstructionView = (props) => {
    const { t } = useTranslation()
    const globalContainerStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginLeft: '24px',
        marginTop: '10px',
        marginBottom: '20px',
        maxWidth: '980px',
        minHeight: '650px',
        backgroundColor: '#FFFFFF'
    }
    return (
        <div>
            <Container xs={12} lg={12} md={12} sm={12} es={12} style={globalContainerStyles}>
                <div className="page-in-construction-container">
                    <img src={imagePageInConstructionImage} alt='pagina en construcción govo.digital' width={'auto'} height={'auto'} />
                    <div className="page-in-contruction-title-and-text-container">
                        <h1 className="page-in-contruction-title-h3">{t('pageInConstruction.titlePageInConstruction')}</h1>
                        {/* <Link to={'/'}> */}
                        <Link to={(props.location.state) ? (props.location.state.fromPage === 'profile') ? '/profile' : '/' : '/'} style={{ textDecoration: 'none' }} >
                            <span className="page-in-construction-button">{t('pageInConstruction.textButton')}</span>
                        </Link>
                    </div>
                </div>
            </Container>
        </div>
    )
}
export { PageInConstructionView as default }